<template>
  <div>
    <HeaderAndFooter>
      <Loader></Loader>
      <v-tabs right class="mr-4">
        <v-tab
          v-for="(folder,ind) in galleryFolders"
          :key="ind"
          @click="changeFolder(folder)"
        >{{folder}}</v-tab>
      </v-tabs>
      <div>
        <VueFluxSlider :images="images"></VueFluxSlider>
      </div>
    </HeaderAndFooter>
  </div>
</template>

<script>
import HeaderAndFooter from "@/components/HeaderAndFooter";
import axios from "@/plugins/axios";
import VueFluxSlider from "@/components/myLibrary/VueFluxSlider.vue";
import Loader from "@/components/Loader.vue";
export default {
  components: { HeaderAndFooter, VueFluxSlider, Loader },
  computed: {
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    }
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios.postData("/auth/get-all-image-folders-post").then(galleryFolders => {
      this.galleryFolders = galleryFolders;
      this.$store.commit("setLoader", false);
    });
  },
  data: () => ({
    galleryFolders: [],
    images: []
  }),
  methods: {
    changeFolder(folder) {
      this.$store.commit("setLoader", true);

      axios
        .postData("/auth/get-images-for-given-folder-emis", {
          folder,
          emis: this.getUserSchool.emis
        })
        .then(images => {
          this.images = [];
          if (images.length > 0) {
            images.forEach(image => {
              this.images.push(
                this.getApiUrl +
                  "/images/" +
                  folder +
                  "/" +
                  this.getUserSchool.emis +
                  "/" +
                  image
              );
            });
          }
          this.$store.commit("setLoader", false);
        });
    }
  }
};
</script>

<style>
</style>